// extracted by mini-css-extract-plugin
module.exports = {"label":"CascadeExecutionStatus_label___eFqX","sent":"CascadeExecutionStatus_sent__1krvW","icon":"CascadeExecutionStatus_icon__2ogpw"};